// Scraped review text (Goodreads) often carries emoji; the site's editorial
// language forbids them, so strip pictographs before rendering.
const EMOJI = /[\p{Extended_Pictographic}\u{FE0F}\u{200D}\u{20E3}]/gu;

export const stripEmoji = (s) => (typeof s === "string" ? s.replace(EMOJI, "").replace(/\s{2,}/g, " ").trim() : s);
